import join from 'url-join';

import { dataLayerPush } from '@libs/analytics';

type TrackNavigationHeaderClickParams = {
    selection: string | string[];
    linkUrl: string;
    navSection?: string;
};

const isAbsoluteUrl = (url: string) => url.startsWith('http');

const formatSelection = (selection: string | string[]) =>
    Array.isArray(selection) ? selection.filter(Boolean).join(' | ') : selection;

export const trackNavigationHeaderClick = ({
    selection,
    linkUrl,
    navSection = 'header nav',
}: TrackNavigationHeaderClickParams) => {
    dataLayerPush({
        event: 'nav_click',
        nav_section: navSection,
        selection: formatSelection(selection),
        link_url: isAbsoluteUrl(linkUrl) ? linkUrl : join(globalThis.location.origin, linkUrl),
    });
};
